<template>
    <div>
        登出成功，線上交易專區期待下次與您相見。
    </div>
</template>
